<template>
    <div class="box-news-headImg">
        <el-carousel height="150px">
            <el-carousel-item v-for="(headImgItem, index) in newsData" :key="index">
                <img class="image-item" :src="headImgItem.image" @click="window.open(headImgItem.link)">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
    export default{
        props: ["newsData", "isAd", "showControl"],
        data(){
            return {
                window: window
            };
        }
    }
</script>
<style lang="less">
    .box-news-headImg{
        .image-item{
            width: 100%;
        }
        .title{
            overflow: hidden;

            .content{
                line-height: 1.4;
                margin-top: 0;
                padding-right: 8px;
            }
        }
        .img-box{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .info-box{
            font-size: 13px;
            color: #8c97a2;
            margin-top: 5px;
            line-height: 1.5;

            .ad-info{
                font-size: 10px;
                padding: 1px 2px;
                border: 1px solid #8c97a2;
            }

            .createTime-box{
                margin-left: 10px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// HeadImg.vue?0d98505e